export default theme => ({

    root: {
        "& > * + *": {
          marginTop: theme.spacing(2)
        }
      },
    tag:1,style:{
      "& .MuiChip-label": {
        color: "blue"
      },
    },
    tag0:{
      "& .MuiChip-label": {
        color: "red"
      },
    },
    tag:2,style:{
      "& .MuiChip-label": {
        color: "yellow"
      },
    },
    tag:3,style:{
      "& .MuiChip-label": {
        color: "green"
      },
    },
  });
  
  